export default __webpack_public_path__ + "static/media/breadcrumbs-title.b42b546b.png";